<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mhVZkj/tc-custom/9781454925767.jpg?1729379439435" alt="This image is the cover for the book Gilded Age"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gilded Age
      </h1>
      <p class="bookDescription body article font2">
        <b>A fully illustrated, insightful portrait of this historic time of dramatic economic growth marked by glamorous haves and struggling have-nots.</b><br/><br/>The Gilded Age—the name coined by Mark Twain to refer to the period of rapid economic growth in America between the 1870s and 1900—offers some intriguing parallels to our own time. Bestselling author and historian Alan Axelrod tackles this subject in a fresh way, exploring this intense era in its various dimensions, and looking at also looks at how it presaged our current era, which many are calling the “Second Gilded Age.” Photographs, political cartoons, engravings, news clippings, and other ephemera help bring this fascinating period into focus.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alan Axelrod
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ef78c990